<template>
    <Carousel class="banner-imgs" v-model="bannerImgIndex" autoplay arrow="never" :dots="images&&images.length>1?'inside':'none'">
        <CarouselItem v-for="bannerImgItem in images" :key="bannerImgItem.id">
            <img class="banner-imgitem" @click.stop.prevent="$emit('bannerItemClicked',bannerImgItem.id)" :src="bannerImgItem.src" />
        </CarouselItem>
    </Carousel>
</template>
<script>
    export default {
        props: {
            images: {
                type: Array,
                required: true
            }
        },
        data: function() {
            return {
                bannerImgIndex: 0
            };
        }
    };
</script>
<style lang="postcss">
.banner-imgitem {
  height: 96px;
  width: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// BannerImages.vue?b2de5f02